import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=b308cb56&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=b308cb56&prod&lang=scss&scoped=true&"
import style1 from "./Faq.vue?vue&type=style&index=1&id=b308cb56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b308cb56",
  null
  
)

export default component.exports